import React, {useCallback, useMemo} from 'react';
import {ScheduleCalendarType} from '../../../../../services';
import dayjs from 'dayjs';
import {Layout, ProgressKind, Spacer, Text, Tooltip} from '@di-nxt/components';
import {ProgressCircleWithDot} from './ProgressCircleWithDot';
import {t} from '../../../../../localization';

type Props = {
  date: Date;
  disabled: boolean;
  percentage: number;
  percentageKind: ProgressKind;
  showDot?: boolean;
  dailyUnassignedTasks: number;
  onChange?: (nextDate: Date, nextCalendarType: ScheduleCalendarType) => void;
};

export const CalendarDateHeaderMonth: React.FC<Props> = ({
  date,
  percentage,
  percentageKind,
  disabled,
  showDot,
  dailyUnassignedTasks,
  onChange,
}) => {
  const handleGotoDay = useCallback(() => {
    onChange && onChange(date, 'day');
  }, [date, onChange]);

  const renderHeaderDay = useMemo(() => {
    return (
      <Layout vertical centered onPress={handleGotoDay}>
        <ProgressCircleWithDot
          percentageProgress={percentage}
          size="16"
          kind={percentageKind}
          showDot={showDot}
        />
        <Spacer height="6" />
        <Text
          textColor={disabled ? 'content_mono_disabled' : undefined}
          align="center"
          variant="inline_12_default">
          {dayjs(date).format('D')}
        </Text>
      </Layout>
    );
  }, [date, disabled, handleGotoDay, percentage, percentageKind, showDot]);
  return (
    <Layout
      height={28}
      horizontal
      flex
      centered
      paddingVertical="10"
      borderRadius="9999"
      backgroundColor="transparent"
      hover>
      {showDot ? (
        <Tooltip
          tooltipText={t('screens.schedule.tooltip.unassigned', {
            tasks: dailyUnassignedTasks
              ? dailyUnassignedTasks?.toString()
              : '0',
          })}
          arrowPosition={'TopRight'}
          trigger={renderHeaderDay}
        />
      ) : (
        <>{renderHeaderDay}</>
      )}
    </Layout>
  );
};
